<template>
    <div class="pointer-events-none w-full items-center">
        <div
            class="flex items-center py-4 pointer-events-none w-full"
            :class="{
                'justify-between': store.getters.isNavigationDrawerClosable,
                'justify-end': !store.getters.isNavigationDrawerClosable,
                'flex absolute px-4': store.getters.isFullScreen,
            }"
        >
            <div v-if="isHamburgerVisible">
                <Button
                    icon="pi pi-bars"
                    class="p-button-rounded p-button-secondary p-shadow-4 pointer-events-auto z-50"
                    @click="store.commit('setIsNavigationDrawerOpen', true)"
                />
            </div>
            <div
                class="flex items-center z-50"
                v-if="isRightHandSide"
            >
                <Dropdown
                    id="course-dropdown"
                    class="mr-8 pointer-events-auto w-64"
                    v-if="courses.length > 0"
                    v-model="selectedCourse"
                    :filter="true"
                    :options="courses"
                    optionLabel="fullName"
                    placeholder="Select a Course"
                >
                    <template #option="slotProps">
                        <div class="text-xs w-52 truncate">
                            {{ slotProps.option.fullName }}
                        </div>
                    </template>
                </Dropdown>
                <AccountMenu class="pointer-events-auto" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
// vue
import {
    defineComponent,
    ref,
    computed,
    onMounted,
    watch,
} from '@vue/composition-api';

// hooks
import { useStore } from '@/store';

// components
import AccountMenu from '@/vue3/components/AccountMenu.vue';
import Dropdown from 'primevue/dropdown';
import Button from 'primevue/button';

export default defineComponent({
    components: {
        AccountMenu,
        Dropdown,
        Button,
    },
    setup(props: any, vm) {
        // hooks
        const store = useStore();

        // refs
        const courses = ref([]);

        // watchers
        watch(
            () => store.state.courseSchemas,
            (newVal) => {
                if (!newVal) return;
                initCourseList(newVal);
            },
        );

        // computed
        const selectedCourse = computed({
            get: () => {
                return courses.value.find(
                    (x: any) => x.id === store.getters.currentCourseSchema.id,
                );
            },
            set: (value: any) => {
                store.commit('setCurrentCourseSchema', value);
                window.location.reload();
            },
        });

        const isNavigationOpen = computed({
            get: () => {
                return store.state.isNavigationDrawerOpen;
            },
            set: (value: boolean) => {
                store.commit('setIsNavigationDrawerOpen', value);
            },
        });

        const isMobile = computed(() => {
            return store.state.isMobile;
        });

        const isRightHandSide = computed(() => {
            const routeName = vm.root.$route.name as string;
            if (['ground2control'].indexOf(routeName) !== -1) return false;
            if (isMobile.value && routeName === 'project-manager') return false;
            return true;
        });

        const isHamburgerVisible = computed(() => {
            if (!store.getters.isNavigationDrawerClosable) return false;
            const routeName = vm.root.$route.name as string;
            if (isMobile.value && routeName === 'project-manager') return false;
            return true;
        });

        // methods
        const initCourseList = (courseList: any): void => {
            if (!store.state.courseSchemas) return;
            courses.value = JSON.parse(courseList).map((x: any) => {
                if (x.CustomDisplayName && x.CustomDisplayName.length > 0) {
                    return {
                        ...x,
                        fullName: x.displayName,
                    };
                } else {
                    x.displayName = x.displayName.replace(/[^a-zA-Z ]/g, '');
                    return {
                        ...x,
                        fullName: x.displayName + (x.tag ? ' - ' + x.tag : ''),
                    };
                }
            });
            courses.value.sort((a: any, b: any) =>
                a.fullName > b.fullName ? 1 : -1,
            );
        };

        // lifecycle
        onMounted((): void => {
            initCourseList(store.state.courseSchemas);
        });

        return {
            store,
            isRightHandSide,
            courses,
            selectedCourse,
            isNavigationOpen,
            isMobile,
            isHamburgerVisible,
        };
    },
});
</script>
